<div class="w-100 m-1 container w-100 m-1 container d-flex flex-column justify-content-between" >
  @if (organizationKey != '') {
    <div>
    <!--div class="my-2 mx-1 p-2" [ngClass]="segment == 'storymap' ? ' selected_module': ''" >
      <a id="discussion" (click)="navigateTo('canvaslist', organizationKey, projectKey)" class="item-title w-100 m-0" href="javascript:void(0);" >
        <span class="clarity--pinboard-solid"></span>
        @if (isMenuExpanded) {
          Canvas @if (canvasCount > 0) { {{canvasCount}} }
        }
      </a>
    </div>
    <div class="my-3 mx-1 p-2" [ngClass]="segment == 'feed'?' selected_module': ''" >
      <a id="discussion" (click)="navigateTo('feed', organizationKey, projectKey)" class="item-title w-100 m-0" href="javascript:void(0);" >
        <span class="hugeicons--knowledge-02"></span>
        @if (isMenuExpanded) {
          Knowledge @if (postCount > 0) { {{postCount}} }
        }
      </a>
    </div>
    <div class="my-3 mx-1 p-2" [ngClass]="segment == 'skanban'?' selected_module': ''" >
      <a id="discussion" (click)="navigateTo('skanban', organizationKey, projectKey)" class="item-title w-100 m-0" href="javascript:void(0);" >
        <span class="tabler--subtask"></span>
        @if (isMenuExpanded) {
          Tasks @if (workpackageCount > 0) { {{workpackageCount}} }
        }
      </a>
    </div>
    <div class="my-3 mx-1 p-2" [ngClass]="segment == 'discussion'?' selected_module': ''" >
      <a id="discussion" (click)="navigateTo('discussion', organizationKey, projectKey)" class="item-title w-100 m-0" href="javascript:void(0);" >
        <span class="octicon--comment-discussion-24"></span>
        @if (isMenuExpanded) {
          Discussions @if (commentCount > 0) { {{commentCount}} }
        }
      </a>
    </div>
    <div class="my-3 mx-1 p-2" [ngClass]="segment == 'news'?' selected_module': ''" >
      <a id="discussion" (click)="navigateTo('news', organizationKey, projectKey)" class="item-title w-100 m-0" href="javascript:void(0);" >
        <span class="fluent--news-28-regular"></span>
        @if (isMenuExpanded) {
          News @if (newsCount > 0) { {{newsCount}} }
        }
      </a>
    </div-->
    <div class="my-3 mx-1 p-2" [ngClass]="segment == 'wiki'?' selected_module': ''" >
      <a id="discussion" (click)="navigateTo('wiki', organizationKey, projectKey)" class="item-title w-100 m-0" href="javascript:void(0);" >
        <span class="mdi--wikipedia me-1"></span>
        @if (isMenuExpanded) {
          Wiki @if (bookCount > 0) { {{bookCount}} }
        }
      </a>
    </div>
  </div>
  <div>
    <div class="mb-1 ms-1 me-1 pt-3 px-2 pb-2 admin-item" [ngClass]="segment == 'startscreen'?' selected_module': ''" >
      <a id="discussion" (click)="navigateTo('startscreen')" class="item-title w-100 m-0" href="javascript:void(0);" >
        <span class="mdi--business"></span>
        @if (isMenuExpanded) {
          Project list
        }
      </a>
    </div>
    @if (isReadOnly == false) {
      <div class="my-3 mx-1 p-2" [ngClass]="segment == 'admin'?' selected_module': ''" >
        <a id="discussion" (click)="navigateTo('admin', organizationKey, projectKey)" class="item-title w-100 m-0" href="javascript:void(0);" >
          <span class="mdi--gear-outline "></span>
          @if (isMenuExpanded) {
            Administration
          }
        </a>
      </div>
    }
    @if (isMenuExpanded) {
      <div class="my-3 mx-1 p-2" >
        <a id="discussion" (click)="expandMenu()" class="item-title w-100 m-0" href="javascript:void(0);" >
          <span class="mdi--arrow-collapse-horizontal"></span>
          Collapse menu
        </a>
      </div>
    } @else {
      <div class="my-3 mx-1 p-2" >
        <a id="discussion" (click)="expandMenu()" class="item-title w-100 m-0" href="javascript:void(0);" >
          <span class="mdi--arrow-expand-horizontal"></span>
        </a>
      </div>
    }
    </div>
  }
</div>